module.exports = __webpack_public_path__ + "img/Vector.bce41e1f.svg";